import { EXPENSE_REQUEST } from '../actions/utilities';

const INITIAL_STATE = {
    getExpenseLoading: false,
    getExpenseSuccess: false,
    getExpenseFailure: false,
    getExpenseError: null,
    deleteExpenseLoading: false,
    deleteExpenseSuccess: false,
    deleteExpenseFailure: false,
    deleteExpenseError: null,
    addExpenseLoading: false,
    addExpenseSuccess: false,
    addExpenseFailure: false,
    addExpenseError: null,
    expenseList: [],
    expenseTypes: [],
    addExpenseTypeLoading: false,
    addExpenseTypeSuccess: false,
    addExpenseTypeFailure: false,
    addExpenseTypeError: null,
    subExpenseList: [],
    getSubExpenseLoading: false,
    getSubExpenseSuccess: false,
    getSubExpenseFailure: false,
    getSubExpenseError: null,
    addSubExpenseLoading: false,
    addSubExpenseSuccess: false,
    addSubExpenseFailure: false,
    addSubExpenseError: null,
    deleteSubExpenseLoading: false,
    deleteSubExpenseSuccess: false,
    deleteSubExpenseFailure: false,
    deleteSubExpenseError: null,
    editSubExpenseLoading: false,
    editSubExpenseSuccess: false,
    editSubExpenseFailure: false,
    editSubExpenseError: null
}

export const expenseReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case EXPENSE_REQUEST.GET_EXPENSE_TYPE_SUCCESS:
            return {
                ...state,
                expenseTypes: action.payload
            }
        case EXPENSE_REQUEST.GET_EXPENSE_REQUEST:
            return {
                ...state,
                getExpenseLoading: true,
                getExpenseSuccess: false,
                getExpenseFailure: false,
                getExpenseError: null
            }
        case EXPENSE_REQUEST.GET_EXPENSE_SUCCESS:
            return {
                ...state,
                getExpenseLoading: false,
                getExpenseSuccess: true,
                getExpenseFailure: false,
                getExpenseError: null,
                expenseList: action.payload

            }
        case EXPENSE_REQUEST.GET_EXPENSE_FAILURE:
            return {
                ...state,
                getExpenseLoading: false,
                getExpenseSuccess: false,
                getExpenseFailure: true,
                getExpenseError: action.payload
            }
        case EXPENSE_REQUEST.DELETE_EXPENSE_REQUEST:
            return {
                ...state,
                deleteExpenseLoading: true,
                deleteExpenseSuccess: false,
                deleteExpenseFailure: false,
                deleteExpenseError: null,
            }
        case EXPENSE_REQUEST.DELETE_EXPENSE_SUCCESS:
            let expenses = state.expenseList;
            for (let i = 0; i < state.expenseList.length; i++) {
                if (expenses[i].expenseId === action.payload) {
                    expenses.splice(i, 1);
                }
            }
            return {
                ...state,
                deleteExpenseLoading: false,
                deleteExpenseSuccess: true,
                deleteExpenseFailure: false,
                deleteExpenseError: null,
                expenseList: expenses

            }
        case EXPENSE_REQUEST.DELETE_EXPENSE_FAILURE:
            return {
                ...state,
                deleteExpenseLoading: false,
                deleteExpenseSuccess: false,
                deleteExpenseFailure: true,
                deleteExpenseError: action.payload,
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_RESET:
            return {
                ...state,
                addExpenseLoading: false,
                addExpenseSuccess: false,
                addExpenseFailure: false,
                addExpenseError: null,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_REQUEST:
            return {
                ...state,
                addExpenseLoading: true,
                addExpenseSuccess: false,
                addExpenseFailure: false,
                addExpenseError: null,
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_SUCCESS:
            return {
                ...state,
                addExpenseLoading: false,
                addExpenseSuccess: true,
                addExpenseFailure: false,
                addExpenseError: null
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_FAILURE:
            return {
                ...state,
                addExpenseLoading: false,
                addExpenseSuccess: false,
                addExpenseFailure: true,
                addExpenseError: action.payload,
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_TYPE_REQUEST:
            return {
                ...state,
                addExpenseTypeLoading: true,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_TYPE_SUCCESS:
            let newExpenseType = state.expenseTypes;
            newExpenseType.push(action.payload)
            return {
                ...state,
                expenseTypes: newExpenseType,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: true,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
            }
        case EXPENSE_REQUEST.ADD_EXPENSE_TYPE_FAILURE:
            return {
                ...state,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: true,
                addExpenseTypeError: action.payload,
            }
        case EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_REQUEST:
            return {
                ...state,
                addExpenseTypeLoading: true,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
            }
        case EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_SUCCESS:
            let expenseType = state.expenseTypes;
            for (let i = 0; i < state.expenseTypes.length; i++) {
                if (expenseType[i].expenseTypeId === action.payload) {
                    expenseType.splice(i, 1);
                }
            }
            return {
                ...state,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: true,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
                expenseTypes: expenseType

            }
        case EXPENSE_REQUEST.DELETE_EXPENSE_TYPE_FAILURE:
            return {
                ...state,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: true,
                addExpenseTypeError: action.payload,
            }
        case EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_REQUEST:
            return {
                ...state,
                addExpenseTypeLoading: true,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
            }
        case EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_SUCCESS:
            let expenseType_ = state.expenseTypes;
            for (let i = 0; i < state.expenseTypes.length; i++) {
                if (expenseType_[i].expenseTypeId === action.payload.expenseTypeId) {
                    expenseType_[i] = action.payload
                }
            }
            return {
                ...state,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: true,
                addExpenseTypeFailure: false,
                addExpenseTypeError: null,
                expenseTypes: expenseType_
            }
        case EXPENSE_REQUEST.EDIT_EXPENSE_TYPE_FAILURE:
            return {
                ...state,
                addExpenseTypeLoading: false,
                addExpenseTypeSuccess: false,
                addExpenseTypeFailure: true,
                addExpenseTypeError: action.payload,
            }
        case EXPENSE_REQUEST.GET_SUBEXPENSE_REQUEST:
            return {
                ...state,
                getSubExpenseLoading: true,
                getSubExpenseSuccess: false,
                getSubExpenseFailure: false,
                getSubExpenseError: null,
            }
        case EXPENSE_REQUEST.GET_SUBEXPENSE_SUCCESS:
            return {
                ...state,
                getSubExpenseLoading: false,
                getSubExpenseSuccess: true,
                getSubExpenseFailure: false,
                getSubExpenseError: null,
                subExpenseList: action.payload
            }
        case EXPENSE_REQUEST.GET_SUBEXPENSE_FAILURE:
            return {
                ...state,
                getSubExpenseLoading: false,
                getSubExpenseSuccess: false,
                getSubExpenseFailure: true,
                getSubExpenseError: action.payload,
            }
        case EXPENSE_REQUEST.ADD_SUBEXPENSE_REQUEST:
            return {
                ...state,
                addSubExpenseLoading: true,
                addSubExpenseSuccess: false,
                addSubExpenseFailure: false,
                addSubExpenseError: null
            }
        case EXPENSE_REQUEST.ADD_SUBEXPENSE_SUCCESS:
            let newSubExpenses = state.subExpenseList;
            newSubExpenses.push(action.payload);
            return {
                ...state,
                addSubExpenseLoading: false,
                addSubExpenseSuccess: true,
                addSubExpenseFailure: false,
                addSubExpenseError: null,
                subExpenseList: newSubExpenses

            }
        case EXPENSE_REQUEST.ADD_SUBEXPENSE_FAILURE:
            return {
                ...state,
                addSubExpenseLoading: false,
                addSubExpenseSuccess: false,
                addSubExpenseFailure: true,
                addSubExpenseError: action.payload,
            }
        case EXPENSE_REQUEST.DELETE_SUBEXPENSE_REQUEST:
            return {
                ...state,
                deleteSubExpenseLoading: true,
                deleteSubExpenseSuccess: false,
                deleteSubExpenseFailure: false,
                deleteSubExpenseError: null
            }
        case EXPENSE_REQUEST.DELETE_SUBEXPENSE_SUCCESS:
            let subExpenses_ = state.subExpenseList;
            for (let i = 0; i < state.subExpenseList.length; i++) {
                if (subExpenses_[i].subExpenseTypeId === action.payload) {
                    subExpenses_.splice(i, 1);
                }
            }
            return {
                ...state,
                deleteSubExpenseLoading: false,
                deleteSubExpenseSuccess: true,
                deleteSubExpenseFailure: false,
                deleteSubExpenseError: null,
                subExpenseList: subExpenses_
            }
        case EXPENSE_REQUEST.DELETE_SUBEXPENSE_FAILURE:
            return {
                ...state,
                deleteSubExpenseLoading: false,
                deleteSubExpenseSuccess: false,
                deleteSubExpenseFailure: true,
                deleteSubExpenseError: action.payload,
            }
        case EXPENSE_REQUEST.EDIT_SUBEXPENSE_REQUEST:
            return {
                ...state,
                editSubExpenseLoading: true,
                editSubExpenseSuccess: false,
                editSubExpenseFailure: false,
                editSubExpenseError: null
            }
        case EXPENSE_REQUEST.EDIT_SUBEXPENSE_SUCCESS:
            let subexpenses_ = state.subExpenseList;
            for (let i = 0; i < state.subExpenseList.length; i++) {
                if (subexpenses_[i].subExpenseTypeId === action.payload.subExpenseTypeId) {
                    subexpenses_[i] = action.payload
                }
            }
            return {
                ...state,
                editSubExpenseLoading: false,
                editSubExpenseSuccess: true,
                editSubExpenseFailure: false,
                editSubExpenseError: null,
                subExpenseList: subexpenses_
            }
        case EXPENSE_REQUEST.EDIT_SUBEXPENSE_FAILURE:
            return {
                ...state,
                editSubExpenseLoading: false,
                editSubExpenseSuccess: false,
                editSubExpenseFailure: true,
                editSubExpenseError: action.payload,
            }
        default:
            return state
    }
}